<script>
export default {
    name: 'image',

    props:
    {
        src: String,
        alt: String,
    },

    render(h)
    {
        return h(
            'div',
            [
                h(
                    'img',
                    {
                        attrs:
                        {
                            src: this.src,
                            alt: this.alt,
                            title: this.title
                        }
                    }
                )
            ]
        )
    }
}
</script>
